import { endsSentence } from "./resay";
import { codePoints, type CompositionToken } from "./schema";

const FIRST_PERSON = /^i(['’]|$)/;

/** Whether a word at `index` would begin its sentence: only punctuation since the last one ended. */
export function beginsSentence(
  tokens: readonly CompositionToken[],
  index: number,
): boolean {
  const before = tokens.slice(0, Math.max(0, index)).reverse();
  const lastEnd = before.findIndex(endsSentence);
  return (lastEnd < 0 ? before : before.slice(0, lastEnd)).every(
    (t) => t.kind === "punct",
  );
}

const capitalized = (word: string): string => {
  const [first = "", ...rest] = codePoints(word);
  return first.toUpperCase() + rest.join("");
};

/**
 * A word the child chose or typed, as the story writes it at `index`: the
 * keyboard and the word list give lower case, so it is capitalized where it
 * begins a sentence, and "I" is always written "I".
 */
export const writtenAt = (
  tokens: readonly CompositionToken[],
  index: number,
  word: string,
): string =>
  FIRST_PERSON.test(word) || beginsSentence(tokens, index)
    ? capitalized(word)
    : word;
